<!--
  - Copyright (c) 2023. Haodong JU
  -->

<script>
import { getNiceRestaurantInfo } from '@/model/dataLayer/service/otherService'
import { loadDashboardDataByDeviceId } from '@/model/dataLayer/service/MultipleStores'
import { getBaseAndUrlForDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

export default {
  name: 'RestaurantLogoDisplay',
  props: {
    date: {},
    size: {
      type: String,
      default: 'normal'
    },
    storeInfo: {}
  },
  data: function () {
    return {
      loading: false,
      currentDateUmsatz: '',
      singleStoreInfo: [],
      storeImage: '',
      storeName: ''
    }
  },
  watch: {
    date: {
      handler: async function (val) {
        await this.reload()
      }
    }
  },
  async mounted () {
    this.singleStoreInfo = this.storeInfo ?? await getNiceRestaurantInfo()
    await this.reload()
    this.storeImage = this.singleStoreInfo.s3LogoUrl
    this.storeName = this.singleStoreInfo.name
  },
  methods: {
    async reload () {
      this.loading = true
      if (this.date) {
        const { url } = await getBaseAndUrlForDeviceId(this.singleStoreInfo?.deviceId)
        const res = await loadDashboardDataByDeviceId(this.date, url)
        this.currentDateUmsatz = res?.taxInfos?.content?.total ?? 0
      }
      this.loading = false
    }
  }
}
</script>

<template>
  <div v-if="loading">
    <v-progress-circular
      indeterminate
      size="24"
    />
  </div>
  <div v-else>
    <div class="d-flex align-center">
      <template v-if="size==='small'">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <v-avatar
              :size="18"
            >
              <v-img
                :src="storeImage ? storeImage : require('@/assets/SaaSImg/type/hotpot.png')"
              >
                <template #placeholder>
                  <v-icon>mdi-emoticon</v-icon>
                </template>
              </v-img>
            </v-avatar>
            <div
              class="text-body-2 ml-1"
            >
              {{ storeName }}
            </div>
          </div>
          <div
            v-if="date"
            class="d-flex align-center justify-center"
          >
            <v-spacer />
            <div class="text-caption">
              {{ currentDateUmsatz === 0 ? '-' : currentDateUmsatz | priceDisplay }}
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="size==='normal'">
        <v-avatar
          :size="24"
          class="mr-3"
        >
          <v-img
            :src="storeImage"
          />
        </v-avatar>
        <div
          v-if="!$vuetify.breakpoint.mobile"
          class="text-body-1"
        >
          {{ storeName }}
        </div>
      </template>
      <template v-else>
        <v-avatar
          :size="36"
          class="mr-3"
        >
          <v-img
            :src="require('@/assets/SaaSImg/type/hotpot.png')"
          />
        </v-avatar>
        <div class="text-h4">
          {{ storeName }}
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>

</style>
